import UserAccountContainer from './UserAccountContainer'

export default UserAccountContainer
